import { Box, Typography } from '@mui/material';
import ExoAvatar from '../ExoAvatar';

// Title of an auto-generated absence event (vacation / sick): the profile
// picture followed by the name of the absent user.
export const CalAbsenceEventLabel = ({ event, size = '14px' }) => {
  const { owner, label } = event;
  const name =
    label || `${owner?.firstName ?? ''} ${owner?.lastName ?? ''}`.trim();

  return (
    <Box className="flex items-center gap-1 w-full overflow-hidden pl-[2px]">
      <ExoAvatar
        picture={owner?.picture?.temporaryUrl}
        name={name}
        size={size}
        sx={{ flexShrink: 0 }}
      />
      <Typography
        fontWeight={500}
        fontSize="11px"
        noWrap
        className="w-full text-left"
      >
        {name}
      </Typography>
    </Box>
  );
};

// Absence events come from the virtual absence calendar and carry their owner.
export function isAbsenceEvent(event) {
  return Boolean(
    event?.owner && (event.type === 'vacation' || event.type === 'sick')
  );
}
